import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { Angle } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bindAll } from '@bibliocommons/utils-react';

import './DidNotFindResourceItem.scss';

import { fixedEncodeURIComponent } from '@bibliocommons/utils-browser';
import { searchEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';

const renderResourceTags = resourceTags =>
  resourceTags.map((tag, index) => (
    <span key={tag}>
      <FormattedMessage id={`${tag}`} />
      {index < resourceTags.size - 1 ? ' | ' : ''}
    </span>
  ));

const injectQueryIntoUrl = (query, url) =>
  query && url ? url.replace(/{query}/gi, fixedEncodeURIComponent(query)) : url;

export default class DidNotFindResourceItem extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    const { resourceName, resourceLink, emptySearch } = this.props;
    sendAnalyticsEvents(
      searchEventComposer.composeDidNotFindResourceClickEvent({
        url: resourceLink,
        text: resourceName,
        emptySearch
      })
    );
  }

  render() {
    const { className, query, resourceName, resourceDescription, resourceTags, resourceLink } = this.props;

    return (
      <li className={`resource-item ${className}`}>
        {resourceName && <h5 className="resource-name">{resourceName}</h5>}
        {resourceDescription && <div className="resource-description">{resourceDescription}</div>}
        <div className="resource-tags">{renderResourceTags(resourceTags)}</div>
        {resourceLink && (
          <a
            className={`did-not-find-resource-link-${resourceName}`}
            href={injectQueryIntoUrl(query, resourceLink)}
            onClick={this.handleClick}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span aria-hidden>
              <FormattedMessage id="search_link_text" />
              <Angle.Right />
            </span>
            <ScreenReaderMessage>
              <FormattedMessage
                id="ada_opens_a_new_tab"
                values={{
                  linkText: <FormattedMessage id="search_resource_link_text" values={{ resourceName }} />
                }}
              />
            </ScreenReaderMessage>
          </a>
        )}
      </li>
    );
  }
}

DidNotFindResourceItem.propTypes = {
  className: PropTypes.string,
  query: PropTypes.string,
  resourceName: PropTypes.string,
  resourceDescription: PropTypes.node,
  resourceTags: ImmutablePropTypes.list,
  resourceLink: PropTypes.string,
  emptySearch: PropTypes.bool
};
